export default __webpack_public_path__ + "static/media/logo.5a952fd0.png";